"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationFieldLogic = void 0;
const clipboard_1 = require("../../clipboard/clipboard");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const migration_1 = require("../../utils/migration");
const intl_1 = require("../../locale/intl");
const date_duration_fieldtype_1 = require("../../safe-field-value/date-fields/date-duration-field/date-duration.fieldtype");
const texts_1 = require("../../texts");
const duration_1 = require("../../utils/duration");
const number_1 = require("../../utils/number");
const validation_1 = require("../../validation/validation");
class DurationFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "durationfield";
        this.label = (0, intl_1.$t)(texts_1.durationFieldText.duration);
        this.icon = "duration";
        this.iconColor = "#3A86FF";
        this.placeholder = (0, intl_1.$t)(texts_1.durationFieldText.type_minutes_hours_or_days);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.durationFieldText.length),
            (0, intl_1.$t)(texts_1.durationFieldText.dd),
            (0, intl_1.$t)(texts_1.durationFieldText.mm),
            (0, intl_1.$t)(texts_1.durationFieldText.yy),
        ];
        this.isNumber = true;
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_equal_to: comparisons_1.isEqualTo,
            is_not_equal_to: comparisons_1.isNotEqualTo,
            is_greater_than: comparisons_1.isGreaterThan,
            is_less_than: comparisons_1.isLessThanAndNotEmpty,
            is_equal_or_greater_than: comparisons_1.isEqualOrGreaterThan,
            is_equal_or_less_than: comparisons_1.isEqualOrLessThanAndNotEmpty,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
        };
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            textfield: clipboard_1.clipboardTextToDuration,
            recordtitlefield: clipboard_1.clipboardTextToDuration,
            textareafield: clipboard_1.clipboardTextToDuration,
            durationfield: clipboard_1.clipboardTextToDuration,
            unknownfield: clipboard_1.clipboardTextToDuration,
            richtextareafield: clipboard_1.clipboardTextToDuration,
        };
        this.fieldValueGetter = new date_duration_fieldtype_1.DateDurationFieldValueGetter();
        this.lookupMode = "lookup";
    }
    get validators() {
        return { required: validation_1.requiredNumber };
    }
    getEmptyValue() {
        return null;
    }
    isValueEmpty(fieldValue, _field) {
        return fieldValue === null || fieldValue === undefined || fieldValue === "";
    }
    getInitialFieldValue(startValue) {
        return startValue
            ? { value: startValue, draft: true }
            : this.getEmptyValue();
    }
    processFieldValue(record, slug, comparison, field) {
        // field value is a string like "0.0" or "3600."
        const fieldValue = super.processFieldValue(record, slug, comparison, field);
        return fieldValue
            ? Math.trunc(fieldValue)
            : fieldValue;
    }
    valueToString(fieldValue, field, ..._rest) {
        var _a, _b;
        if (fieldValue || fieldValue === 0) {
            return (0, duration_1.formatDisplayDuration)(Number(fieldValue), (_a = field.params.display_format) !== null && _a !== void 0 ? _a : "compact", (_b = field.params.duration_format) !== null && _b !== void 0 ? _b : "hh:mm", true);
        }
        return "";
    }
    sortKey(fieldValue, _field) {
        if (fieldValue === null || fieldValue === undefined || fieldValue === "") {
            return Number.NEGATIVE_INFINITY;
        }
        return Number(fieldValue);
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editorWidth: "100%",
        };
    }
    getLinkedRecordFieldSmartWidth(field) {
        const widthOptions = {
            compact: {
                defaultWidht: 90,
                minWidth: 45,
            },
            standard: {
                defaultWidht: 110,
                minWidth: 55,
            },
            long: {
                defaultWidht: 120,
                minWidth: 60,
            },
        };
        const width = widthOptions[field.params.display_format];
        return {
            defaultWidht: width.defaultWidht,
            minWidth: width.minWidth,
        };
    }
    migrateField(fieldTo, fieldFrom) {
        var _a;
        const migratedField = super.migrateField(fieldTo, fieldFrom);
        return (0, migration_1.migrateDisplayFormat)(migratedField, types_1.durationDisplayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        const hours = Number((Number(fieldValue) / 3600).toFixed(1));
        const formatted = super.metricWidgetValueToString(hours, field, userPreferences);
        return `${formatted} hours`;
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is_equal_to" && (0, number_1.isNumeric)(filterValue)) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
}
exports.DurationFieldLogic = DurationFieldLogic;
